import router from "@/router";
import UserInfoStore from "@/utils/UserInfoStore";
import setTitle from "@/utils/setTiele";
import TokenStore from "@/utils/tokenStore";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({ showSpinner: false });

const List = ["/login"];

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  document.title = setTitle(to.meta.title);
  const hasToken = TokenStore.getToken("operators");
  const hasUserInfo = UserInfoStore.getInfo();
  if (hasToken && hasUserInfo) {
    if (to.path === "/login" && !to.query.from_admin_token) {
      next({ path: "/" });
      NProgress.done();
    } else {
      next();
    }
  } else {
    if (List.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/login?redirect=${to.fullPath}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
